import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

import { CSS_RESTRICTIONS } from '@common/constants';

@Directive()
export abstract class AbstractSignalSettingsComponent<T> implements OnInit, OnDestroy {
    @Output() public cancelEvent = new EventEmitter<void>();

    public readonly CSS_RESTRICTIONS = CSS_RESTRICTIONS;

    protected cachedValue: T | null = null;

    protected abstract readFormValue(): T;
    protected abstract writeFormValue(value: T): void;

    public ngOnInit(): void {
        this.cachedValue = structuredClone(this.readFormValue());
        this.initSubscriptions();
    }

    public initSubscriptions(): void {}

    public onSave(): void {
        this.cachedValue = structuredClone(this.readFormValue());
        this.cancelEvent.emit();
    }

    public onReset(): void {
        if (this.cachedValue !== null) {
            this.writeFormValue(structuredClone(this.cachedValue));
        }
        this.cancelEvent.emit();
    }

    public onCancel(): void {
        this.cancelEvent.emit();
    }

    public ngOnDestroy(): void {
        if (this.cachedValue !== null && this.hasChanges()) {
            this.writeFormValue(structuredClone(this.cachedValue));
        }
    }

    private hasChanges(): boolean {
        return JSON.stringify(this.readFormValue()) !== JSON.stringify(this.cachedValue);
    }

    @HostListener('document:keydown.enter')
    public onEnterKeyPress(): void {
        if (this.saveDisablePredicate) {
            return;
        }
        this.onSave();
    }

    @HostListener('document:keydown.escape', ['$event'])
    public onEscapeKeyPress(event: KeyboardEvent): void {
        event.stopPropagation();
        this.onCancel();
    }

    public get saveDisablePredicate(): boolean {
        return false;
    }
}
